export default __webpack_public_path__ + "static/media/create-from-scratch.815907f4.svg";